import { createContext } from 'react';
import UseAuth from '../hooks/UseAuth';

export const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
    const { authenticated, user, loading, authenticate, logout } = UseAuth();
    return (
        <AuthContext.Provider value={{ authenticated, user, loading, authenticate, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
